<template>
  <div class="language-switcher">
    <select v-model="currentLocale" @change="changeLanguage">
      <option value="zh">中文</option>
      <option value="en">English</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLocale: this.$i18n.locale
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.currentLocale
      // 保存语言选择到localStorage
      localStorage.setItem('locale', this.currentLocale)
      this.$emit('getLocale', this.currentLocale)
    }
  },
  mounted() {
    // 从localStorage恢复语言选择
    const savedLocale = localStorage.getItem('locale')
    if (savedLocale) {
      this.currentLocale = savedLocale
      this.$i18n.locale = savedLocale
    }
  }
}
</script>

<style scoped>
.language-switcher {
  
}

.language-switcher select {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #141415;
  font-size: 14px;
  color: #fff;
  border-radius: 16px;
  cursor: pointer;
}

.language-switcher select:focus {
  outline: none;
  border-color: #007bff;
}
</style>
